import { Common } from '@thecvlb/design-system/lib/src';

import { ConfirmNoneOfHealthConcernsProps } from './confirmNoneOfHealthConcerns.types';

const ConfirmNoneOfHealthConcerns: React.FC<ConfirmNoneOfHealthConcernsProps> = ({
  onContinue,
  onClose
}) => {
  return (
    <div>
      <h3 className="mb-2 text-xl font-bold">
        Please confirm you have not experienced any of the listed health conditions.
      </h3>
      <p className="mb-6 text-base font-medium">
        Note: Selecting conditions will help your provider confirm that an appropriate personalized
        compound of semaglutide is right for you.
      </p>
      <div className="flex flex-col-reverse gap-3 md:flex-row">
        <Common.Button className="grow" color="white-alt" fullWidthOnMobile onClick={onClose}>
          No, review list
        </Common.Button>
        <Common.Button className="grow" color="blue" fullWidthOnMobile onClick={onContinue}>
          Yes, I’m sure
        </Common.Button>
      </div>
    </div>
  );
};

export default ConfirmNoneOfHealthConcerns;
